import JSZip from "jszip";

export const unzipFile = async (inputZipFile: File): Promise<File[]> => {
    try {
        const zip = new JSZip();
        const unzippedFiles = [];

        const zipBuffer = await inputZipFile.arrayBuffer();
        const zipData = await zip.loadAsync(zipBuffer);

        for (const [relativePath, zipEntry] of Object.entries(zipData.files)) {
            if (!zipEntry.dir) {
                const fileContentArray = await zipEntry.async("uint8array");
                const blob = new Blob([fileContentArray], { type: "application/octet-stream" });
                const file = new File([blob], relativePath, { type: "application/vnd.google-earth.kml+xml" });
                unzippedFiles.push(file);
            }
        }

        return unzippedFiles;
    } catch (error) {
        console.error("Error unzipping file:", error);
        return null;
    }
};

export const blobToKmz = async (inputBlob: Blob, fileName: string): Promise<Blob> => {
    try {
        const zip = new JSZip();

        zip.file(fileName + ".kml", inputBlob);
        const zipBlob = await zip.generateAsync({
            type: "blob",
            mimeType: "application/vnd.google-earth.kmz"
        });
        return zipBlob;
    } catch (error) {
        console.error("Error zipping file:", error);
        return null;
    }
};
